/**
 * GUIControlType enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file GUIControlType.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum GUIControlType {
  Invalid   = -1,
  Panel     = 2,
  Label     = 4,
  ProtoItem = 5,
  Button    = 6,
  CheckBox  = 7,
  Slider    = 8,
  ScrollBar = 9,
  Progress  = 10,
  Listbox   = 11
}